import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Translate, I18n } from 'react-redux-i18n'
import Grid from 'material-ui/Grid'
import Button from 'material-ui/Button'
import copy from 'copy-to-clipboard'
import { ShareButtons, generateShareIcon } from 'react-share'

import currentUserSelector from 'selectors/current_user'
import parametersSelector from 'selectors/parameters'

export const social_share_button_tag = (title, { url, allow_sites }) => {
  const {
    FacebookShareButton,
    GooglePlusShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    PinterestShareButton,
    VKShareButton,
    OKShareButton,
    RedditShareButton,
    TumblrShareButton,
    EmailShareButton
  } = ShareButtons

  const mapping = {
    google_plus: 'google',
    vkontakte: 'vk',
    odnoklassniki: 'ok'
  }

  const filter = {
    facebook: FacebookShareButton,
    twitter: TwitterShareButton,
    telegram: TelegramShareButton,
    whatsapp: WhatsappShareButton,
    google: GooglePlusShareButton,
    linkedin: LinkedinShareButton,
    pinterest: PinterestShareButton,
    vk: VKShareButton,
    ok: OKShareButton,
    reddit: RedditShareButton,
    tumblr: TumblrShareButton,
    email: EmailShareButton
  }

  return (
    <div className="social-share-button">
      {allow_sites.filter(network => filter[network]).map(network => {
        const Button = filter[network]
        const Icon = generateShareIcon(mapping[network] || network)
        return (
          <Button key={network} url={url} title={title} media={url}>
            <Icon size={25} round />
          </Button>
        )
      })}
    </div>
  )
}

const ReferralLink = ({ config_parameters, current_user }) => (
  <div>
    <h3>{I18n.t('referral.h')}</h3>
    <Grid container direction="column">
      <Grid item container className="refer-link referral-link" spacing={0}>
        <Grid item xs={10}>
          <p id="refer-link-box">{current_user.referral_link}</p>
        </Grid>
        <Grid item xs={2}>
          <Button id="refer-copy-link" onClick={() => copy(current_user.referral_link)}>
            {I18n.t('referral.copy')}
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <span>
          <p>
            <Translate
              value="main.step.referral_link_html"
              percent={config_parameters['referral.percent_to_referrer']}
              coin_ticker={config_parameters['coin.tiker']}
              dangerousHTML
            />
          </p>
        </span>
      </Grid>
    </Grid>
  </div>
)

const mapStateToProps = state => ({
  current_user: currentUserSelector(state),
  config_parameters: parametersSelector(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ReferralLink)



// WEBPACK FOOTER //
// ./src/containers/pages/profile/referral_link.js